<template>
  <van-row class="check-item shadow">
    <van-col :span="4">
      <van-radio :name="item.id"/>
    </van-col>
      
    <van-col
      :offset="1"
      :span="hasRightValue ? 7 : 22"
      :class="hasRightValue"
      style="display: flex;"
    >
      <!-- :class="hasRightValue && 'van-ellipsis'" -->
      {{
        item.projectCode || item.costCenterCode || item.svalue || item.name || item.cName || item.gzmc || item.reasonDesc || item.groupName
      }}
    </van-col>




    <van-col
      :offset="1"
      :span="15"
    >
      {{ item.projectName || item.costCenterName || item.district || item.gzdm || item.groupNumber }}
      {{ item.ccsy }}
    </van-col>
  </van-row>
</template>
  
<script>
import {RadioGroup, Radio} from 'vant'
export default {
  components: {
    [RadioGroup.name]: RadioGroup,
    [Radio.name]: Radio,
  },
  props: {
    item: {
      type: Object,
      default: () => {
      }
    }
  },
  computed: {
    hasRightValue() {
      let item = this.item
      return item.projectName || item.costCenterName || item.district || item.gzdm || item.ccsy || item.groupName
    }
  }
}
</script>
  
  <style lang="less" scoped>
  .check-item {
    padding: 15px 10px;
    display: flex;
  }
  </style>